"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormAppend = void 0;
var react_1 = __importDefault(require("react"));
var AcFormFieldBadge_1 = require("./AcFormFieldBadge");
var AcFormField_module_scss_1 = __importDefault(require("./AcFormField.module.scss"));
var FaIcon_1 = require("../util/FaIcon");
// Layout for the AC Form
var AcFormAppend = function (_a) {
    var required = _a.required, append = _a.append, size = _a.size, type = _a.type, readOnly = _a.readOnly, onIconClick = _a.onIconClick, onClearClick = _a.onClearClick;
    return (react_1.default.createElement("div", { className: "d-flex align-items-center " + (type !== 'select' ? AcFormField_module_scss_1.default.appendDiv : AcFormField_module_scss_1.default.appendDivSelect) },
        onClearClick && !readOnly && (react_1.default.createElement("span", { onClick: onClearClick, className: "mr-3" },
            react_1.default.createElement(FaIcon_1.FaIcon, { variant: "apzashblue", icon: "far fa-times", "fa-fw": true, size: "medium" }))),
        required && !readOnly && type && !['radio', 'checkbox', 'switch'].includes(type) && (react_1.default.createElement("span", { className: "mr-3" },
            react_1.default.createElement(AcFormFieldBadge_1.AcFormFieldBadge, { type: "required", size: size }))),
        append && (react_1.default.createElement("span", { className: "mr-3", onClick: onIconClick }, append))));
};
exports.AcFormAppend = AcFormAppend;
exports.AcFormAppend.displayName = 'AcFormAppend';
//# sourceMappingURL=AcFormAppend.js.map